module.exports = __webpack_public_path__ + "img/52114121_L.c345c3d9.png";